export const economicCodes = [
  {
    SERIAL_NO: 1,
    ECON_CODE: 1142199,
    ECON_NAME_EN: "Excise duty",
    ECON_NAME_BN: "আবগারি শুল্ক",
  },
  {
    SERIAL_NO: 2,
    ECON_CODE: 8113304,
    ECON_NAME_EN: "Deposit work",
    ECON_NAME_BN: "কাজের জন্য জমা",
  },
  {
    SERIAL_NO: 3,
    ECON_CODE: 8113509,
    ECON_NAME_EN: "Personal ledger account deposit",
    ECON_NAME_BN: "ব্যক্তিগত লেজার অ্যাকাউন্ট জমা",
  },
  {
    SERIAL_NO: 4,
    ECON_CODE: 1422208,
    ECON_NAME_EN: "Birth and death registration fee",
    ECON_NAME_BN: "জন্ম ও মৃত্যু নিবন্ধন ফি",
  },
  {
    SERIAL_NO: 5,
    ECON_CODE: 1423234,
    ECON_NAME_EN: "Radiological examination charge",
    ECON_NAME_BN: "রেডিওলজিকেল পরীক্ষা চার্জ",
  },
  {
    SERIAL_NO: 6,
    ECON_CODE: 1144102,
    ECON_NAME_EN: "Travel tax",
    ECON_NAME_BN: "ভ্রমণ কর",
  },
  {
    SERIAL_NO: 7,
    ECON_CODE: 8113508,
    ECON_NAME_EN: "Deposit against lease of vested properties",
    ECON_NAME_BN: "অর্পিত সম্পত্তি ইজারার বিপরীতে জমা",
  },
  {
    SERIAL_NO: 8,
    ECON_CODE: 8112202,
    ECON_NAME_EN: "General provident fund (defence)",
    ECON_NAME_BN: "সাধারণ ভবিষ্য তহবিল (প্রতিরক্ষা)",
  },
  {
    SERIAL_NO: 9,
    ECON_CODE: 1423231,
    ECON_NAME_EN: "Ambulance charge",
    ECON_NAME_BN: "এ্যাম্বুলেন্স চার্জ",
  },
  {
    SERIAL_NO: 10,
    ECON_CODE: 1144101,
    ECON_NAME_EN: "Advertising tax",
    ECON_NAME_BN: "বিজ্ঞাপন কর",
  },
  {
    SERIAL_NO: 11,
    ECON_CODE: 3244101,
    ECON_NAME_EN: "Travel Expense",
    ECON_NAME_BN: "ভ্রমণ ব্যয়",
  },
  {
    SERIAL_NO: 12,
    ECON_CODE: 8113501,
    ECON_NAME_EN: "Election deposit",
    ECON_NAME_BN: "নির্বাচনি জমা",
  },
  {
    SERIAL_NO: 13,
    ECON_CODE: 1411204,
    ECON_NAME_EN: "Interest on S T D accounts",
    ECON_NAME_BN: "স্বল্প মেয়াদি জমার সুদ",
  },
  {
    SERIAL_NO: 14,
    ECON_CODE: 8113102,
    ECON_NAME_EN: "Pension deposit",
    ECON_NAME_BN: "পেনশন জমা",
  },
  {
    SERIAL_NO: 15,
    ECON_CODE: 8113104,
    ECON_NAME_EN: "Criminal court deposit",
    ECON_NAME_BN: "ফৌজদারি আদালতের জমা",
  },
  {
    SERIAL_NO: 16,
    ECON_CODE: 1421307,
    ECON_NAME_EN: "Garage rent",
    ECON_NAME_BN: "গ্যারেজ ভাড়া",
  },
  {
    SERIAL_NO: 17,
    ECON_CODE: 8172503,
    ECON_NAME_EN: "Employee benevolent fund",
    ECON_NAME_BN: "কর্মচারী কল্যাণ তহবিল",
  },
  {
    SERIAL_NO: 18,
    ECON_CODE: 1423103,
    ECON_NAME_EN: "Sale of edible oil",
    ECON_NAME_BN: "ভোজ্য তেল বিক্রয়",
  },
  {
    SERIAL_NO: 19,
    ECON_CODE: 8172504,
    ECON_NAME_EN: "Employee group insurance fund",
    ECON_NAME_BN: "কর্মচারী যৌথবিমা তহবিল",
  },
  {
    SERIAL_NO: 20,
    ECON_CODE: 4143102,
    ECON_NAME_EN: "Tree, crop, and plant resources yielding repeat products",
    ECON_NAME_BN: "বৃক্ষ, শস্য ও উদ্ভিজ্জসম্পদ উৎপন্নকারী আবর্তক পণ্য",
  },
  {
    SERIAL_NO: 21,
    ECON_CODE: 1162201,
    ECON_NAME_EN: "Development surcharge",
    ECON_NAME_BN: "উন্নয়ন সারর্চাজ",
  },
  {
    SERIAL_NO: 22,
    ECON_CODE: 8172401,
    ECON_NAME_EN: "Titas gas bill",
    ECON_NAME_BN: "তিতাস গ্যাস বিল",
  },
  {
    SERIAL_NO: 23,
    ECON_CODE: 1423252,
    ECON_NAME_EN: "Sale of mouza map",
    ECON_NAME_BN: "মৌজা ম্যাপ বিক্রয়",
  },
  {
    SERIAL_NO: 24,
    ECON_CODE: 1441205,
    ECON_NAME_EN: "Leave salary contribution",
    ECON_NAME_BN: "ছুটির বেতন বাবদ চাঁদা",
  },
  {
    SERIAL_NO: 25,
    ECON_CODE: 8112203,
    ECON_NAME_EN: "General provident fund (Railway)",
    ECON_NAME_BN: "সাধারণ ভবিষ্য তহবিল (রেলওয়ে)",
  },
  {
    SERIAL_NO: 26,
    ECON_CODE: 8172404,
    ECON_NAME_EN: "Karnaphuli gas bill",
    ECON_NAME_BN: "কর্ণফুলী গ্যাস বিল",
  },
  {
    SERIAL_NO: 27,
    ECON_CODE: 1422303,
    ECON_NAME_EN: "Police clearance fee",
    ECON_NAME_BN: "পুলিশ ক্লিয়ারেন্স ফি",
  },
  {
    SERIAL_NO: 28,
    ECON_CODE: 1422305,
    ECON_NAME_EN: "Admiralty suite fee",
    ECON_NAME_BN: "এ্যাডমিরালটি স্যুট ফি",
  },
  {
    SERIAL_NO: 29,
    ECON_CODE: 1441206,
    ECON_NAME_EN: "Pension and gratuity contribution",
    ECON_NAME_BN: "অবসর ভাতা ও আনুতোষিক বাবদ চাঁদা",
  },
  {
    SERIAL_NO: 30,
    ECON_CODE: 8172403,
    ECON_NAME_EN: "Jalalabad gas bill",
    ECON_NAME_BN: "জালালাবাদ গ্যাস বিল",
  },
  {
    SERIAL_NO: 31,
    ECON_CODE: 1156101,
    ECON_NAME_EN: "Embarkation fee",
    ECON_NAME_BN: "আরোহণ ফি",
  },
  {
    SERIAL_NO: 32,
    ECON_CODE: 8113103,
    ECON_NAME_EN: "Civil court deposit",
    ECON_NAME_BN: "দেওয়ানি আদালতের জমা",
  },
  {
    SERIAL_NO: 33,
    ECON_CODE: 1112101,
    ECON_NAME_EN: "Income tax payable by companies",
    ECON_NAME_BN: "কোম্পানিসমূহ কর্তৃক দেয় আয়কর",
  },
  {
    SERIAL_NO: 34,
    ECON_CODE: 7215202,
    ECON_NAME_EN: "Development loan",
    ECON_NAME_BN: "উন্নয়ন ঋণ",
  },
  {
    SERIAL_NO: 35,
    ECON_CODE: 1111101,
    ECON_NAME_EN: "Income tax payable by individuals",
    ECON_NAME_BN: "ব্যক্তি কর্তৃক দেয় আয়কর",
  },
  {
    SERIAL_NO: 36,
    ECON_CODE: 1141101,
    ECON_NAME_EN: "VAT on domestic products and services",
    ECON_NAME_BN: "দেশজ পণ্য ও সেবার ওপর মূসক",
  },
  {
    SERIAL_NO: 37,
    ECON_CODE: 1422311,
    ECON_NAME_EN: "Passport fee",
    ECON_NAME_BN: "পাসপোর্ট ফি",
  },
  {
    SERIAL_NO: 38,
    ECON_CODE: 1412203,
    ECON_NAME_EN: "Dividends (cash) from non financial institutions",
    ECON_NAME_BN: "অআর্থিক প্রতিষ্ঠান থেকে প্রাপ্ত লভ্যাংশ (নগদ)",
  },
  {
    SERIAL_NO: 39,
    ECON_CODE: 1141102,
    ECON_NAME_EN: "Supplementary duty on domestically produced commodities",
    ECON_NAME_BN: "দেশজ উৎপাদিত পণ্যের ওপর সম্পূরক শুল্ক",
  },
  {
    SERIAL_NO: 40,
    ECON_CODE: 1411201,
    ECON_NAME_EN: "Interest on loan to autonomous bodies",
    ECON_NAME_BN: "স্বায়ত্বশাসিত সংস্থাকে প্রদত্ত ঋণের সুদ",
  },
  {
    SERIAL_NO: 41,
    ECON_CODE: 1151101,
    ECON_NAME_EN: "Customs duty",
    ECON_NAME_BN: "কাস্টমস শুল্ক",
  },
  {
    SERIAL_NO: 42,
    ECON_CODE: 1411203,
    ECON_NAME_EN: "Interest on foreign loan on lent",
    ECON_NAME_BN: "পুনর্বিনিয়োগকৃত বৈদেশিক ঋণের সুদ",
  },
  {
    SERIAL_NO: 43,
    ECON_CODE: 1151102,
    ECON_NAME_EN: "Supplementary duty",
    ECON_NAME_BN: "সম্পূরক শুল্ক",
  },
  {
    SERIAL_NO: 44,
    ECON_CODE: 1412201,
    ECON_NAME_EN: "Dividends (cash) from financial institutions",
    ECON_NAME_BN: "আর্থিক প্রতিষ্ঠান থেকে প্রাপ্ত লভ্যাংশ (নগদ)",
  },
  {
    SERIAL_NO: 45,
    ECON_CODE: 1441202,
    ECON_NAME_EN: "Recovery of over payment from prior years",
    ECON_NAME_BN: "পূর্ববর্তী অর্থবছরের অতিরিক্ত গৃহীত অর্থ ফেরত",
  },
  {
    SERIAL_NO: 46,
    ECON_CODE: 1141103,
    ECON_NAME_EN: "Supplementary duty on domestic services",
    ECON_NAME_BN: "দেশজ সেবার ওপর সম্পূরক শুল্ক",
  },
  {
    SERIAL_NO: 47,
    ECON_CODE: 1423209,
    ECON_NAME_EN: "User fee",
    ECON_NAME_BN: "ইউজার ফি",
  },
  {
    SERIAL_NO: 48,
    ECON_CODE: 1421101,
    ECON_NAME_EN: "Passenger fare",
    ECON_NAME_BN: "যাত্রী ভাড়া",
  },
  {
    SERIAL_NO: 49,
    ECON_CODE: 1141104,
    ECON_NAME_EN: "VAT on imported commodities",
    ECON_NAME_BN: "আমদানি পণ্যের ওপর মূসক",
  },
  {
    SERIAL_NO: 50,
    ECON_CODE: 1423228,
    ECON_NAME_EN: "Sale of rations",
    ECON_NAME_BN: "রেশন বিক্রয়",
  },
  {
    SERIAL_NO: 51,
    ECON_CODE: 1422335,
    ECON_NAME_EN: "Renewal fee",
    ECON_NAME_BN: "নবায়ন ফি",
  },
  {
    SERIAL_NO: 52,
    ECON_CODE: 1421102,
    ECON_NAME_EN: "Charges from goods",
    ECON_NAME_BN: "পণ্য পরিবহণ ভাড়া",
  },
  {
    SERIAL_NO: 53,
    ECON_CODE: 1422307,
    ECON_NAME_EN: "Tuition fee",
    ECON_NAME_BN: "টিউশন ফি",
  },
  {
    SERIAL_NO: 54,
    ECON_CODE: 1441299,
    ECON_NAME_EN: "Other receipts",
    ECON_NAME_BN: "অন্যান্য আদায়",
  },
  {
    SERIAL_NO: 55,
    ECON_CODE: 1423101,
    ECON_NAME_EN: "Sale of rice",
    ECON_NAME_BN: "চাল বিক্রয়",
  },
  {
    SERIAL_NO: 56,
    ECON_CODE: 1431101,
    ECON_NAME_EN: "Fines",
    ECON_NAME_BN: "জরিমানা",
  },
  {
    SERIAL_NO: 57,
    ECON_CODE: 1131101,
    ECON_NAME_EN: "Land development tax",
    ECON_NAME_BN: "ভূমি উন্নয়ন কর",
  },
  {
    SERIAL_NO: 58,
    ECON_CODE: 1422320,
    ECON_NAME_EN: "Mutation fee",
    ECON_NAME_BN: "নামজারি ও জমাখারিজ ফি",
  },
  {
    SERIAL_NO: 59,
    ECON_CODE: 1423205,
    ECON_NAME_EN: "Hospital bed charge",
    ECON_NAME_BN: "হাসপাতালের বিছানার চার্জ",
  },
  {
    SERIAL_NO: 60,
    ECON_CODE: 1422330,
    ECON_NAME_EN: "Health and family planning services fee",
    ECON_NAME_BN: "স্বাস্থ্য ও পরিবার পরিকল্পনা সেবা ফি",
  },
  {
    SERIAL_NO: 61,
    ECON_CODE: 1422402,
    ECON_NAME_EN: "Charge for document copying",
    ECON_NAME_BN: "দলিল নকল চার্জ",
  },
  {
    SERIAL_NO: 62,
    ECON_CODE: 1422102,
    ECON_NAME_EN: "Firearms license fee",
    ECON_NAME_BN: "আগ্নেয়াস্ত্র লাইসেন্স ফি",
  },
  {
    SERIAL_NO: 63,
    ECON_CODE: 1141301,
    ECON_NAME_EN: "Turnover tax",
    ECON_NAME_BN: "টার্নওভার ট্যাক্স",
  },
  {
    SERIAL_NO: 64,
    ECON_CODE: 1423208,
    ECON_NAME_EN: "Fee for uniform",
    ECON_NAME_BN: "ইউনিফর্ম ফি",
  },
  {
    SERIAL_NO: 65,
    ECON_CODE: 1423247,
    ECON_NAME_EN: "Lease of estates",
    ECON_NAME_BN: "ভূ-সম্পত্তি ইজারা",
  },
  {
    SERIAL_NO: 66,
    ECON_CODE: 1422329,
    ECON_NAME_EN: "Testing fee",
    ECON_NAME_BN: "টেস্টিং ফি",
  },
  {
    SERIAL_NO: 67,
    ECON_CODE: 1422323,
    ECON_NAME_EN: "Court fee",
    ECON_NAME_BN: "কোর্ট ফি",
  },
  {
    SERIAL_NO: 68,
    ECON_CODE: 1422403,
    ECON_NAME_EN: "Electricity charge",
    ECON_NAME_BN: "বিদ্যুৎ চার্জ",
  },
  {
    SERIAL_NO: 69,
    ECON_CODE: 1422302,
    ECON_NAME_EN: "National Identification card fee",
    ECON_NAME_BN: "জাতীয় পরিচয়পত্র ফি",
  },
  {
    SERIAL_NO: 70,
    ECON_CODE: 7215103,
    ECON_NAME_EN: "Interest free loan",
    ECON_NAME_BN: "সুদমুক্ত ঋণ",
  },
  {
    SERIAL_NO: 71,
    ECON_CODE: 1423204,
    ECON_NAME_EN: "Fee for using government vehicle",
    ECON_NAME_BN: "সরকারি যানবাহন ব্যবহার ফি",
  },
  {
    SERIAL_NO: 72,
    ECON_CODE: 1423202,
    ECON_NAME_EN:
      "Fee for commercial broadcasting services ( sales of advertising times)",
    ECON_NAME_BN: "বাণিজ্যিক সম্প্রচার সেবা ফি (বিজ্ঞাপন সময় বিক্রি বাবদ)",
  },
  {
    SERIAL_NO: 73,
    ECON_CODE: 1421302,
    ECON_NAME_EN: "Rentals- residential",
    ECON_NAME_BN: "ভাড়া- আবাসিক",
  },
  {
    SERIAL_NO: 74,
    ECON_CODE: 1421202,
    ECON_NAME_EN: "Postage realised in cash",
    ECON_NAME_BN: "নগদ আদায়কৃত ডাক মাশুল",
  },
  {
    SERIAL_NO: 75,
    ECON_CODE: 1422328,
    ECON_NAME_EN: "Tender document fee",
    ECON_NAME_BN: "দরপত্র দলিল ফি",
  },
  {
    SERIAL_NO: 76,
    ECON_CODE: 1421301,
    ECON_NAME_EN: "Rentals ( non residential)",
    ECON_NAME_BN: "ভাড়া( অনাবাসিক)",
  },
  {
    SERIAL_NO: 77,
    ECON_CODE: 1422201,
    ECON_NAME_EN: "Document registration fee",
    ECON_NAME_BN: "দলিল নিবন্ধন ফি",
  },
  {
    SERIAL_NO: 78,
    ECON_CODE: 1422199,
    ECON_NAME_EN: "Other license fee",
    ECON_NAME_BN: "অন্যান্য লাইসেন্স ফি",
  },
  {
    SERIAL_NO: 79,
    ECON_CODE: 1423225,
    ECON_NAME_EN: "Sale of paper and stationery",
    ECON_NAME_BN: "কাগজ ও স্টেশনারি বিক্রয়",
  },
  {
    SERIAL_NO: 80,
    ECON_CODE: 1411202,
    ECON_NAME_EN: "Interest on loan to government employees",
    ECON_NAME_BN: "সরকারি কর্মচারীকে প্রদত্ত ঋণের সুদ",
  },
  {
    SERIAL_NO: 81,
    ECON_CODE: 1421105,
    ECON_NAME_EN: "Parcel",
    ECON_NAME_BN: "পার্সেল",
  },
  {
    SERIAL_NO: 82,
    ECON_CODE: 1422326,
    ECON_NAME_EN: "Examination fee",
    ECON_NAME_BN: "পরীক্ষা ফি",
  },
  {
    SERIAL_NO: 83,
    ECON_CODE: 1423227,
    ECON_NAME_EN: "Sale of plants and seedlings",
    ECON_NAME_BN: "উদ্ভিজ্জ ও চারা বিক্রয়",
  },
  {
    SERIAL_NO: 84,
    ECON_CODE: 1423102,
    ECON_NAME_EN: "Sale of wheat",
    ECON_NAME_BN: "গম বিক্রয়",
  },
  {
    SERIAL_NO: 85,
    ECON_CODE: 1423226,
    ECON_NAME_EN: "Sale of used paper and stationery",
    ECON_NAME_BN: "ব্যবহৃত কাগজ ও স্টেশনারি বিক্রয়",
  },
  {
    SERIAL_NO: 86,
    ECON_CODE: 1431103,
    ECON_NAME_EN: "Forfeiture",
    ECON_NAME_BN: "বাজেয়াপ্তকরণ",
  },
  {
    SERIAL_NO: 87,
    ECON_CODE: 1423221,
    ECON_NAME_EN: "Sale of medicines and vaccines",
    ECON_NAME_BN: "ঔষধ ও প্রতিষেধক বিক্রয়",
  },
  {
    SERIAL_NO: 88,
    ECON_CODE: 2112101,
    ECON_NAME_EN: "Motor vehicle",
    ECON_NAME_BN: "মোটরযান",
  },
  {
    SERIAL_NO: 89,
    ECON_CODE: 1421303,
    ECON_NAME_EN: "Tolls on bridges",
    ECON_NAME_BN: "সেতুর ওপর টোল",
  },
  {
    SERIAL_NO: 90,
    ECON_CODE: 1422404,
    ECON_NAME_EN: "Water and sewerage charge",
    ECON_NAME_BN: "পানি ও পয়ঃনিষ্কাশন ব্যবস্থা চার্জ",
  },
  {
    SERIAL_NO: 91,
    ECON_CODE: 1422318,
    ECON_NAME_EN: "Survey fee",
    ECON_NAME_BN: "জরিপ ফি",
  },
  {
    SERIAL_NO: 92,
    ECON_CODE: 1441204,
    ECON_NAME_EN:
      "Municipal tax payable by government employee living in govt accommodation",
    ECON_NAME_BN: "সরকারি আবাসনে বসবাসকারী সরকারি কর্মচারী কর্তৃক দেয় পৌরকর",
  },
  {
    SERIAL_NO: 93,
    ECON_CODE: 1423201,
    ECON_NAME_EN: "Admission fee",
    ECON_NAME_BN: "ভর্তি ফি",
  },
  {
    SERIAL_NO: 94,
    ECON_CODE: 2141101,
    ECON_NAME_EN: "Sale/disposal of land",
    ECON_NAME_BN: "জমি বিক্রয়/নিষ্পত্তি",
  },
  {
    SERIAL_NO: 95,
    ECON_CODE: 1423206,
    ECON_NAME_EN: "Security services charge",
    ECON_NAME_BN: "নিরাপত্তা সেবা চার্জ",
  },
  {
    SERIAL_NO: 96,
    ECON_CODE: 1422205,
    ECON_NAME_EN: "Marriage registration fee",
    ECON_NAME_BN: "বিবাহ নিবন্ধন ফি",
  },
  {
    SERIAL_NO: 97,
    ECON_CODE: 1413101,
    ECON_NAME_EN: "Withdrawals from income of quasi-corporations",
    ECON_NAME_BN: "কুয়াসি-কর্পোরেশনের উদ্বৃত্ত আয়",
  },
  {
    SERIAL_NO: 98,
    ECON_CODE: 7215205,
    ECON_NAME_EN: "On lent foreign loan",
    ECON_NAME_BN: "বৈদেশিক ঋণের ভিত্তিতে দেয় ঋণ",
  },
  {
    SERIAL_NO: 99,
    ECON_CODE: 1162203,
    ECON_NAME_EN: "Health development surcharge",
    ECON_NAME_BN: "স্বাস্থ্য  উন্নয়ন সারর্চাজ",
  },
  {
    SERIAL_NO: 100,
    ECON_CODE: 1162101,
    ECON_NAME_EN: "Stamp duty",
    ECON_NAME_BN: "স্ট্যাম্প ডিউটি",
  },
  {
    SERIAL_NO: 101,
    ECON_CODE: 1423248,
    ECON_NAME_EN: "Lease of hats and bazars",
    ECON_NAME_BN: "হাটবাজার ইজারা",
  },
  {
    SERIAL_NO: 102,
    ECON_CODE: 1422325,
    ECON_NAME_EN: "Engineering service fee",
    ECON_NAME_BN: "প্রকৌশল সেবা ফি",
  },
  {
    SERIAL_NO: 103,
    ECON_CODE: 1422312,
    ECON_NAME_EN: "Transfer fee",
    ECON_NAME_BN: "হস্তান্তর ফি",
  },
  {
    SERIAL_NO: 104,
    ECON_CODE: 1431104,
    ECON_NAME_EN: "Sale of confiscated items",
    ECON_NAME_BN: "বাজেয়াপ্ত দ্রব্য বিক্রয়",
  },
  {
    SERIAL_NO: 105,
    ECON_CODE: 1421104,
    ECON_NAME_EN: "Rent of catering carriage",
    ECON_NAME_BN: "ক্যাটারিং ক্যারেজ ভাড়া",
  },
  {
    SERIAL_NO: 106,
    ECON_CODE: 1415202,
    ECON_NAME_EN: "Lease of water bodies (jal mahal, ponds)",
    ECON_NAME_BN: "জলমহাল ও পুকুর ইজারা",
  },
  {
    SERIAL_NO: 107,
    ECON_CODE: 1421201,
    ECON_NAME_EN: "Sale of stamp",
    ECON_NAME_BN: "স্ট্যাম্প  বিক্রয়",
  },
  {
    SERIAL_NO: 108,
    ECON_CODE: 1162102,
    ECON_NAME_EN: "Duty on impressing documents",
    ECON_NAME_BN: "ছাপযুক্ত দলিলের ওপর শুল্ক",
  },
  {
    SERIAL_NO: 109,
    ECON_CODE: 1423230,
    ECON_NAME_EN: "Artificial insemination charge",
    ECON_NAME_BN: "কৃত্রিম প্রজনন চার্জ",
  },
  {
    SERIAL_NO: 110,
    ECON_CODE: 1421306,
    ECON_NAME_EN: "Seat Rent",
    ECON_NAME_BN: "সিট ভাড়া",
  },
  {
    SERIAL_NO: 111,
    ECON_CODE: 1422322,
    ECON_NAME_EN: "Quarantine certification fee",
    ECON_NAME_BN: "সংগনিরোধক সনদ ফি",
  },
  {
    SERIAL_NO: 112,
    ECON_CODE: 7215101,
    ECON_NAME_EN: "House building loan",
    ECON_NAME_BN: "গৃহনির্মাণ ঋণ",
  },
  {
    SERIAL_NO: 113,
    ECON_CODE: 8173201,
    ECON_NAME_EN: "Departmental challan remittance",
    ECON_NAME_BN: "বিভাগীয় চালান রেমিটেন্স",
  },
  {
    SERIAL_NO: 114,
    ECON_CODE: 1145301,
    ECON_NAME_EN: "Radio and television licenses",
    ECON_NAME_BN: "রেডিও ও টেলিভিশন লাইসেন্স",
  },
];
